// extracted by mini-css-extract-plugin
module.exports = {"Not-found":"not-found_Not-found__BoVTQ","Not-found__link":"not-found_Not-found__link__gR_pT"};